import CloneFinished from './CloneFinished';
import Clone from './Clone';
import Deprecate from './Deprecate';
import Migrate from './Migrate';
import Promote from './Promote';
import Status from './Status';
import { getServerErrorBlock } from './utils';

export {
  CloneFinished as CloneFinishedModal,
  Clone as CloneModal,
  Deprecate as DeprecateModal,
  Migrate as MigrateModal,
  Promote as PromoteModal,
  Status as StatusModal,
  getServerErrorBlock,
};
export default {
  CloneFinished,
  Clone,
  Deprecate,
  Migrate,
  Promote,
  Status,
};
